import * as broker from './broker';

const settings = {};
let launcher;
let closer;

export function close() {
    if (closer) {
        closer();
    }
}

export function get(name) {
    return settings[name];
}

export function launch(path, options, preventClose = false, hideHeaderBar = false) {
    if (options) {
        Object.keys(options).forEach(function(k) {
            set(k, options[k]);
        });
    }
    if (launcher) {
        launcher(path, preventClose, hideHeaderBar);
    }
}

function set(name, val) {
    if (val === null) {
        delete settings[name];
    } else {
        settings[name] = val;
    }
    broker.publish(`modal:set:${name}`, val);
}

export function onSet(name, fn) {
    broker.subscribe('modalService', `modal:set:${name}`, function(ev) {
        fn(ev.data);
    });
}

export function destroy(name) {
    broker.unsubscribe('modalService', `modal:set:${name}`);
}

export function onLaunch(fn) {
    launcher = fn;
}

export function onClose(fn) {
    closer = fn;
}
